import React from 'react'
import classNames from 'classnames'
import { t } from '@lingui/macro'
import Button, { ButtonType } from 'components/buttons/button/Button'
import styles from './PaymentResultView.module.scss'

export type PaymentResultStatus = 'success' | 'error'

type Props = {
  status: PaymentResultStatus
  title: string
  text: string
  onClose: () => void
}

// Centered result screen shown after a redirect/3DS reentry, mimicking the
// Adyen Drop-in's animated success/error state (green check / red cross).
export const PaymentResultView = ({ status, title, text, onClose }: Props) => {
  const isSuccess = status === 'success'
  return (
    <div className={styles.Result}>
      <span
        className={classNames(
          styles.IconCircle,
          isSuccess ? styles.Success : styles.Error
        )}
      >
        <svg className={styles.Icon} viewBox="0 0 52 52" aria-hidden="true">
          <circle className={styles.Ring} cx="26" cy="26" r="24" />
          {isSuccess ? (
            <path className={styles.Mark} d="M15 27 l7 7 l15 -15" />
          ) : (
            <>
              <path className={styles.Mark} d="M18 18 l16 16" />
              <path className={styles.Mark} d="M34 18 l-16 16" />
            </>
          )}
        </svg>
      </span>
      <h2 className={styles.Title}>{title}</h2>
      <p className={styles.Text}>{text}</p>
      <Button
        customStyle={styles.CloseButton}
        label={t`Close`}
        onClick={onClose}
        type={ButtonType.GhostWithBoarder}
        buttonSize="Medium"
      />
    </div>
  )
}
